'use strict';

/* Directives */

module.exports = angular.module('superdostavka.commonDirectives', [])
// Фото товара в окнах, которые приходят отдельным запросом (lazy-render): адрес ставится после
// загрузки заглушки. На странице атрибут preload заменяет загрузчик первого экрана.
.directive('preload', function() {
    return {
        link: function(scope, element, attrs) {
            element[0].addEventListener('load', () => element[0].setAttribute('src', attrs.preload), { once: true });
        }
    };
})
// Меню закрепляется вверху экрана, когда страница прокручена ниже его места.
.directive('stickScroll', ['$window', function($window) {
    return {
        link: function(scope, element, attrs) {
            const node = element[0];
            let offset = 0;
            $window.addEventListener('scroll', function() {
                if (!offset) {
                    offset = node.getBoundingClientRect().top + $window.pageYOffset - document.documentElement.clientTop - 4;
                }
                const sticked = $window.pageYOffset > offset;
                node.classList.toggle(attrs.stickClass, sticked);
                scope.$eval(attrs.stickCallback, { sticked: sticked });
            });
        }
    };
}])
.directive('cart', function() {
    return {
        restrict: 'E',
        templateUrl: '/angular/cart.html',
        link: function (scope, el, attr) {
            scope.showPosition = attr.showPosition === undefined ? true : attr.showPosition;
        }
    };
})
.directive('modal', ['modal', '$document', '$timeout', 'maxAuthManager', 'unibellAuthManager', function(modal, $document, $timeout, maxAuthManager, unibellAuthManager) {
    // Окна входа через MAX и звонок Unibell опрашивают сервер, пока открыты.
    function pauseLogin(id) {
        if (id === 'maxLogin' && (maxAuthManager.status === 'pending' || maxAuthManager.status === 'loading')) {
            maxAuthManager.pause();
        } else if (id === 'unibellCallMe' && (unibellAuthManager.callMeStatus === 'pending' || unibellAuthManager.callMeStatus === 'loading')) {
            unibellAuthManager.pauseCallMe();
        }
    }

    return {
        link: function(scope, element, attrs) {
            const id = attrs.modal;
            // hide-outside="[[ false ]]": окно не закрывается щелчком вне его.
            const hideOutside = attrs.hideOutside === undefined ? true : scope.$eval(attrs.hideOutside);

            modal.setNew(id, element, attrs.addClass);
            modal.hide(id);
            modal.hide(id, false);

            scope.$watch(function() {
                return modal.isVisible(id);
            }, function(show) {
                if (show) {
                    $timeout(() => {
                        // Карту в окне грузим только после открытия: в скрытом блоке Яндекс строит пустую карту.
                        element[0].querySelectorAll('.ya-map[data-yandex-map-src]:not([data-yandex-map-loaded])').forEach(map => {
                            const script = document.createElement('script');
                            script.src = map.getAttribute('data-yandex-map-src');
                            map.setAttribute('data-yandex-map-loaded', '1');
                            map.appendChild(script);
                        });
                    });
                } else {
                    // Скрытие окна MAX останавливает только опрос: попытка входа живёт в сессии PHP до TTL.
                    pauseLogin(id);
                }
            });

            $document[0].addEventListener('click', function(e) {
                if (element[0].classList.contains('ng-hide')) {
                    return;
                }
                if (e.target.attributes['modal-close'] !== undefined) {
                    modal.hide(id, true);
                    return;
                }
                if (e.target.attributes['no-hide-modal'] !== undefined || hideOutside !== true) {
                    return;
                }
                const click = e.target.getAttribute('ng-click');
                if (click && (click.indexOf('modal.toggle') != -1 || click.indexOf('toggleModal') != -1) && click.indexOf(id) != -1) {
                    return;
                }
                if (element[0].contains(e.target)) {
                    return;
                }
                modal.hide(id, false);
            });

            scope.$on('$destroy', () => pauseLogin(id));
        }
    };
}])
.directive("preloadResource", ["resourceCache", function(resourceCache) {
    return {
        link: function (scope, element, attrs) {
            resourceCache.put(attrs.preloadResource, element[0].innerHTML);
        }
    };
}])
// Окна и блоки, которые сервер отдаёт отдельным запросом после загрузки страницы.
.directive('lazyRender', ['$http', '$compile', function($http, $compile) {
    return {
        restrict: 'E',
        link: function (scope, ele, attrs) {
            const node = ele[0];
            node.setAttribute('ng-cloak', '');
            $http.get('/rapi/renderTemplate', {params: {name: attrs.name, variables: attrs.variables}}).then((res) => {
                node.innerHTML = res.data;
                $compile(node.childNodes)(scope);
                node.querySelectorAll('script').forEach(script => {
                    // Скрипт из ответа не выполняется. Адрес конструктора Яндекс.Карт сохраняется
                    // у блока карты, а карта грузится при открытии окна.
                    let src = script.getAttribute('src') || (script.innerHTML.match(/https:\/\/api-maps\.yandex\.ru\/services\/constructor\/1\.0\/js\/\?[^"']+/) || [])[0];
                    if (!src || src.indexOf('api-maps.yandex.ru/services/constructor') === -1) {
                        return;
                    }

                    // В старых инфоблоках script может стоять перед <div class="ya-map">.
                    let map = script.parentNode.classList && script.parentNode.classList.contains('ya-map') ? script.parentNode : null;
                    for (let next = script.nextSibling; !map && next; next = next.nextSibling) {
                        if (next.classList && next.classList.contains('ya-map')) {
                            map = next;
                        }
                    }
                    map = map || node.querySelector('.ya-map:not([data-yandex-map-src]):not([data-yandex-map-loaded])');

                    if (!map || map.getAttribute('data-yandex-map-loaded')) {
                        return;
                    }

                    map.setAttribute('data-yandex-map-src', src.replace(/&amp;/g, '&'));
                    script.parentNode.removeChild(script);
                });
                node.removeAttribute('ng-cloak');
                // Пока reCAPTCHA загружается, у grecaptcha ещё нет render: тогда окно капчи отрисует
                // grecaptchaCallback, когда reCAPTCHA будет готова.
                if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render === 'function') {
                    grecaptcha.render('recaptcha', {callback: res => document.getElementById('grecaptcha-input').value = res});
                }
            });
        }
    };
}])
// Большое фото товара: пока оно загружается, видна заставка #preview-spinner.
.directive("smartSrc", function() {
    return {
        link: function(scope, element, attrs) {
            const spinner = document.getElementById('preview-spinner');
            scope.$watch(() => attrs.smartSrc, (value, previous) => {
                if (value === previous) {
                    return;
                }
                spinner.style.display = 'block';
                element[0].style.display = 'none';
                const img = new Image();
                img.src = attrs.smartSrc;
                img.onload = function() {
                    spinner.style.display = 'none';
                    element[0].src = attrs.smartSrc;
                    element[0].style.display = 'block';
                };
            });
        }
    };
});
